import { getAppStore, postEntity } from '../../../../../@data';
import { Publisher } from '../../../../../@data/store';
import { AddressValidation } from '../../../../../@data/store/schema/models/AddressValidation';

export async function validateAddressAsync(body: AddressValidation, publisher: Publisher) {
  const { userContext } = getAppStore();
  const addressValidation = await postEntity([publisher], AddressValidation, body, userContext);
  return addressValidation;
}
